var babyfriendly = (function (namespace) {
    namespace.bindButtonClickToToggleClass = function (buttonId, targetId, className) {
        $(buttonId).click(function () {
            $(targetId).toggleClass(className);
            return false;
        });
    };

    namespace.forceInputToBeNumeric = function (inputSelector) {
        $(inputSelector).forceNumeric();
    };

    namespace.forceInputToBeInteger = function (inputSelector) {
        $(inputSelector).forceInteger();
    };

    namespace.bindBreastfeedingInitiationRate = function (numDischargesId, numBreastfeedingId, targetId) {
        $.each([$(numDischargesId), $(numBreastfeedingId)], function (index, component) {
            component.change(function () {
                var numDischarges = parseInt($(numDischargesId).val(), 10);
                var numBreastfeeding = parseInt($(numBreastfeedingId).val(), 10);

                if (namespace.anyIsNaN(numDischarges, numBreastfeeding)) {
                    $(targetId).val('');
                }
                else {
                    $(targetId).val(namespace.calculateBreastfeedingInitiationRate(numDischarges, numBreastfeeding));
                }
            });
        });
    };

    namespace.bindExclusivelyBreastfedRate = function (numEligibleId, numExclusivelyBreastfedId, targetId) {
        $.each([$(numEligibleId), $(numExclusivelyBreastfedId)], function (index, component) {
            component.change(function () {
                var numEligible = parseInt($(numEligibleId).val(), 10);
                var numExclusivelyBreastfed = parseInt($(numExclusivelyBreastfedId).val(), 10);

                if (namespace.anyIsNaN(numEligible, numExclusivelyBreastfed)) {
                    $(targetId).val('');
                }
                else {
                    $(targetId).val(namespace.calculateExclusivelyBreastfedRate(numEligible, numExclusivelyBreastfed));
                }
            });
        });
    };

    namespace.bindFormulaUseRate = function (numEligibleId, numExclusivelyBreastfedId, numGivenFormulaId, targetId) {
        $.each([$(numEligibleId), $(numExclusivelyBreastfedId), $(numGivenFormulaId)], function (index, component) {
            component.change(function () {
                var numEligible = parseInt($(numEligibleId).val(), 10);
                var numExclusivelyBreastfed = parseInt($(numExclusivelyBreastfedId).val(), 10);
                var numGivenFormula = parseInt($(numGivenFormulaId).val(), 10);

                if (namespace.anyIsNaN(numEligible, numExclusivelyBreastfed, numGivenFormula)) {
                    $(targetId).val('');
                }
                else {
                    $(targetId).val(namespace.calculateFormulaUseRate(numEligible, numExclusivelyBreastfed, numGivenFormula));
                }
            });
        });
    };

    namespace.calculateBreastfeedingInitiationRate = function (numDischarges, numBreastfeeding) {
        if (numDischarges === 0) {
            return '';
        }

        return Math.round((numBreastfeeding / numDischarges) * 100);
    };

    namespace.calculateExclusivelyBreastfedRate = function (numEligible, numExclusivelyBreastfed) {
        if (numEligible === 0) {
            return '';
        }

        return Math.round((numExclusivelyBreastfed / numEligible) * 100);
    };

    namespace.calculateFormulaUseRate = function (numEligible, numExclusivelyBreastfed, numGivenFormula) {
        var denominator = numEligible - numExclusivelyBreastfed;

        if (denominator === 0) {
            return '';
        }

        return Math.round((numGivenFormula / denominator) * 100);
    };

    namespace.anyIsNaN = function () {
        var numberOfArguments = arguments.length;

        for (var index = 0; index < numberOfArguments; index++) {
            if (isNaN(arguments[index])) {
                return true;
            }
        }
        return false;
    };

    namespace.bindPercentageCalculation = function (numeratorId, denominatorId, targetId) {
        $.each([$(numeratorId), $(denominatorId)], function (index, component) {
            component.change(function () {
                var numerator = parseInt($(numeratorId).val(), 10);
                var denominator = parseInt($(denominatorId).val(), 10);

                if (namespace.anyIsNaN(numerator, denominator)) {
                    $(targetId).val('');
                } else if (denominator === 0) {
                    $(targetId).val('');
                }
                else {
                    $(targetId).val(Math.round((numerator / denominator) * 100));
                }
            });
        });
    };

    namespace.addMoreButton = function (sourceInput, buttonId) {
        var elements = $(sourceInput);
        $(elements).hide();
        var showElements = $(sourceInput + ".show")
        for (var i = 0; i < showElements.length; i++) {
            $(showElements[i]).show();
        }
        if (showElements.length >= elements.length) {
            $(buttonId).addClass('disabled');
        }
        if (showElements.length < 1) {
            $(elements[0]).show();
        }
        $(buttonId).click(function (e) {
            e.preventDefault();
            var hiddenEls = $(sourceInput + ":hidden");
            if (hiddenEls.length > 1) {
                $(hiddenEls[0]).show();
            }
            else if (hiddenEls.length == 1) {
                $(hiddenEls[0]).show();
                $(buttonId).addClass('disabled');
            } else {
                $(buttonId).addClass('disabled');
            }
        });
    };

    namespace.scrollToTop = function () {
        $('.back-to-top a').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    };

    namespace.externalLinks = function () {
        $('a').each(function () {
            var a = new RegExp('/' + window.location.host + '/');
            if (!a.test(this.href)) {
                $(this).click(function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    window.open(this.href, '_blank');
                });
            }
        });
    };

    namespace.bindButtonToSlideToggleTarget = function (buttonId, targetId) {
        $(buttonId).click(function (e) {
            e.preventDefault();

            $(targetId).slideToggle('slow');
        });
    };

    namespace.bindButtonToToggleTarget = function (buttonId, targetId) {
        $(buttonId).click(function (e) {
            e.preventDefault();

            $(targetId).toggle();
        });
    };

    namespace.manageOptionalFacilityDataSheetFields = function () {
        var that = this;

        $('#facility_data_sheet_maternity_care_service_attributes_provides_prenatal_services').click(function () {
            if (this.checked) {
                that.enableOptionalPrenatalFields();
            } else {
                that.disableOptionalPrenatalFields();
            }
        });
    };

    namespace.disableOptionalPrenatalFields = function () {
        $('#optional-questions input').prop('disabled', true);
        $('#optional-questions').hide();
        $('#optional-questions-text').show();
    };

    namespace.enableOptionalPrenatalFields = function () {
        $('#optional-questions input').prop('disabled', false);
        $('#optional-questions-text').hide();
        $('#optional-questions').show();
    };

    return namespace;
})(babyfriendly || {});


(function ($) {
    // Borrowed from: http://www.west-wind.com/weblog/posts/2011/Apr/22/Restricting-Input-in-HTML-Textboxes-to-Numeric-Values
    $.fn.forceNumeric = function () {
        return this.each(function () {
            $(this).keydown(function (e) {
                var key = e.which || e.keyCode;

                if (!e.shiftKey && !e.altKey && !e.ctrlKey &&
                    // numbers
                    key >= 48 && key <= 57 ||
                    // Numeric keypad
                    key >= 96 && key <= 105 ||
                    // comma, period and minus, . on keypad
                    key == 190 || key == 188 || key == 109 || key == 110 ||
                    // other minus
                    key == 189 ||
                    // Backspace and Tab and Enter
                    key == 8 || key == 9 || key == 13 ||
                    // Home and End
                    key == 35 || key == 36 ||
                    // left and right arrows
                    key == 37 || key == 39 ||
                    // Del and Del on keypad and Ins
                    key == 46 || key === 0 || key == 45)
                    return true;

                return false;
            });
        });
    };

    $.fn.forceInteger = function () {
        return this.each(function () {
            $(this).keydown(function (e) {
                var key = e.which || e.keyCode;

                if (!e.shiftKey && !e.altKey && !e.ctrlKey &&
                    // numbers
                    key >= 48 && key <= 57 ||
                    // Numeric keypad
                    key >= 96 && key <= 105 ||
                    // Backspace and Tab and Enter
                    key == 8 || key == 9 || key == 13 ||
                    // Home and End
                    key == 35 || key == 36 ||
                    // left and right arrows
                    key == 37 || key == 39 ||
                    // Del and Del on keypad and Ins
                    key == 46 || key === 0 || key == 45)
                    return true;

                return false;
            });
        });
    };

    $.fn.paymentTypeDropdown = function (args) {
        return this.each(function () {
            this.parseArgs = function (args) {
                if (args !== undefined) {
                    this.creditCardContainerID = args.creditCardContainerID;
                    this.creditCardTextFieldID = args.creditCardTextFieldID;
                    this.creditCardOptionText = args.creditCardOptionText;
                }

                if (!this.creditCardContainerID) {
                    this.creditCardContainerID = '#credit-card-type-container';
                }

                if (!this.creditCardTextFieldID) {
                    this.creditCardTextFieldID = '#payment_credit_card_type';
                }

                if (!this.creditCardOptionText) {
                    this.creditCardOptionText = 'Credit Card';
                }
            };

            function handleInputState() {
                if (this.creditCardIsSelected()) {
                    this.showCreditCardContainer();
                } else {
                    this.hideCreditCardContainer();
                    this.clearCreditCardType();
                }
            }

            this.bindEvents = function () {
                $(this).change(handleInputState.bind(this));
            };

            this.hideCreditCardContainer = function () {
                $(this.creditCardContainerID).hide();
                this.clearCreditCardType();
            };

            this.showCreditCardContainer = function () {
                $(this.creditCardContainerID).show();
                $(this.creditCardTextFieldID).show();
            };

            this.clearCreditCardType = function () {
                $(this.creditCardTextFieldID).val('');
            };

            this.selectedOptionText = function () {
                return $('option:selected', this).text();
            };

            this.creditCardIsSelected = function () {
                return this.selectedOptionText() === this.creditCardOptionText;
            };

            this.parseArgs(args);
            this.bindEvents();
            handleInputState.call(this);
        });
    };
}(jQuery));
